import { AuthXService } from 'core/auth';
import { FC } from 'react';

export const AccessView: FC = () => {
    return <>{AuthXService.isAuthenticated() ? 'true' : 'false'}</>;
};
import { AuthXService } from 'core/auth';
import { FC } from 'react';

export const AccessView: FC = () => {
    return <>{AuthXService.isAuthenticated() ? 'true' : 'false'}</>;
};
